import { render, staticRenderFns } from "./commentOrk.vue?vue&type=template&id=af472b6e&"
import script from "./commentOrk.vue?vue&type=script&lang=js&"
export * from "./commentOrk.vue?vue&type=script&lang=js&"
import style0 from "./commentOrk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports